// extracted by mini-css-extract-plugin
module.exports = {"Button":"button-module--Button--2Jud-","Large":"button-module--Large--3Enm_","Medium":"button-module--Medium--oLdRW","Small":"button-module--Small--1RCzu"};